import React from "react";
import "./BlockPlaceholder.css";

const BlockPlaceholder = ({ height, message }) => {
  if (message)
    return (
      <h1 className=" p-5 d-flex align-items-center justify-content-center text-muted text-center display-4" style={{ height: height + "px" }}>
        {message}
      </h1>
    );
  else
    return (
      <div className="placeholder" style={{ height: height + "px" }}>
        <div className="animated_background" style={{ height: height + "px" }} />
      </div>
    );
};

export default BlockPlaceholder;
